import {lazy} from '@aboutyou/lazy-imports';

export const SizeReminder = lazy(() =>
  import('./SizeReminder').then(mod => ({default: mod.SizeReminder})),
);
